var React = require('react');

function PlusInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 7.05477V8.83513C13.4278 8.72963 10.7611 8.67688 8 8.67688L8.77891 8.68057C8.78688 11.1999 8.83928 13.6397 8.93609 16L7.15573 16C7.26123 13.4278 7.31398 10.7611 7.31398 8L7.31065 8.67798C4.79444 8.68605 2.35755 8.73844 8.75922e-08 8.83513L0 7.05477C2.57223 7.16028 5.2389 7.21303 8 7.21303L7.31253 7.21034C7.30341 4.72966 7.25114 2.32621 7.15573 0L8.93609 8.75922e-08C8.83058 2.57223 8.77783 5.2389 8.77783 8L8.78089 7.21161C11.2647 7.20258 13.671 7.1503 16 7.05477Z","fill":"black"}));
}

PlusInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = PlusInline;

PlusInline.default = PlusInline;
